var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9583 7.08464H14.6667C15.0579 7.08464 15.375 7.40176 15.375 7.79297V14.8763C15.375 15.2675 15.0579 15.5846 14.6667 15.5846H3.33333C2.94213 15.5846 2.625 15.2675 2.625 14.8763V7.79297C2.625 7.40176 2.94213 7.08464 3.33333 7.08464H4.04167V6.3763C4.04167 3.63789 6.26159 1.41797 9 1.41797C11.7384 1.41797 13.9583 3.63789 13.9583 6.3763V7.08464ZM12.5417 7.08464V6.3763C12.5417 4.4203 10.956 2.83464 9 2.83464C7.04399 2.83464 5.45833 4.4203 5.45833 6.3763V7.08464H12.5417ZM8.29167 9.91797V12.7513H9.70833V9.91797H8.29167Z",
    fill: "#7a7a7a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateIcon);
export default __webpack_public_path__ + "static/media/privateIcon.b2f265ee.svg";
export { ForwardRef as ReactComponent };